import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { ToolbarDatePicker } from "./ToolbarDatepicker";

export interface ToolbarDateNavigationProps {
  selectedDate: Date;
  canGoNext: boolean;
  previousLabel: string;
  nextLabel: string;
  onDateChange: (newDate: Date) => void;
  onPrevious: () => void;
  onNext: () => void;
  compact?: boolean;
}

export function ToolbarDateNavigation({
  selectedDate,
  canGoNext,
  previousLabel,
  nextLabel,
  onDateChange,
  onPrevious,
  onNext,
  compact = false,
}: ToolbarDateNavigationProps) {
  const classes = useStyles();
  const buttonSize = compact ? "small" : "medium";

  return (
    <div className={compact ? classes.compactRoot : classes.root}>
      <Tooltip title={previousLabel}>
        <IconButton
          aria-label={previousLabel}
          size={buttonSize}
          onClick={onPrevious}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Tooltip>
      <div
        className={compact ? classes.compactDatePicker : classes.datePicker}
      >
        <ToolbarDatePicker
          selectedDate={selectedDate}
          onDateChange={onDateChange}
          compact={compact}
        />
      </div>
      <Tooltip title={nextLabel}>
        <span>
          <IconButton
            aria-label={nextLabel}
            size={buttonSize}
            onClick={onNext}
            disabled={!canGoNext}
          >
            <ChevronRightIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-end",
  },
  compactRoot: {
    display: "flex",
    alignItems: "center",
  },
  datePicker: {
    flexGrow: 1,
    margin: theme.spacing(0, 1),
  },
  compactDatePicker: {
    margin: theme.spacing(0, 1),
  },
}));
